module.exports = __webpack_public_path__ + "img/partner4.2caf40eb.png";